// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"bfc99276","425":"3a3512fa","510":"63f7fb71","532":"414d80e7","633":"3aa4caa9","634":"8adf53dc","922":"04672385","937":"81fc0b61","972":"7ef20488"}[chunkId] + ".chunk.js";
};